module.exports = __webpack_public_path__ + "img/sandra.4429234c.jpeg";